module.exports = __webpack_public_path__ + "img/03.b34646c8.jpg";